import React, { useState, useEffect } from "react";
import { Row, Col, Typography, Breadcrumb, Menu, message, Spin } from "antd";
import { Link } from "react-router-dom";
import { BiDetail } from "react-icons/bi";
import { IoCheckmarkCircle, IoPeopleCircleSharp } from "react-icons/io5";
import {
	getAccountDetails,
	getCompanyDetails,
	getCountryCodes,
} from "api/customApis";
import AccountDetails from "./AccountDetails";
import CompanyDetails from "./CompanyDetails";
import UserManagement from "../UserManagement";
import "./styles.css";

const { Title } = Typography;

export default function ProfileSettings() {
	const [tabKey, setTabKey] = useState("1");
	const [accountDetails, setAccountDetails] = useState(null);
	const [companyDetails, setCompanyDetails] = useState(null);
	const [countryCodes, setCountryCodes] = useState([]);
	const [loading, setLoading] = useState(true);

	const fetchData = async () => {
		try {
			const res1 = await getAccountDetails();
			setAccountDetails(res1?.data?.data);
			const res2 = await getCompanyDetails(res1?.data?.data?.org);
			setCompanyDetails(res2?.data?.data);
		} catch (e) {
			message.error("Failed to fetch data");
			setLoading(false);
		}
	};

	useEffect(async () => {
		try {
			await fetchData();
			const res3 = await getCountryCodes();
			setCountryCodes(res3.data.data);
			setLoading(false);
		} catch (e) {
			message.error("Failed to fetch data");
			setLoading(false);
		}
	}, []);

	const renderHeader = () => {
		return (
			<>
				<Row>
					<Breadcrumb>
						<Breadcrumb.Item>
							<Link to="/" onClick={() => {}}>
								Home
							</Link>
						</Breadcrumb.Item>
						<Breadcrumb.Item>Settings</Breadcrumb.Item>
					</Breadcrumb>
				</Row>
				<Row justify="space-between" style={{ marginTop: "1rem" }}>
					<Title level={2} style={{ fontFamily: "Gilroy" }}>
						Profile Settings
					</Title>
				</Row>
			</>
		);
	};

	const renderBody = () => {
		if (loading)
			return (
				<Spin
					size="large"
					style={{ display: "flex", justifyContent: "center" }}
				/>
			);
		if (tabKey === "1")
			return (
				<AccountDetails
					data={accountDetails}
					fetchData={fetchData}
					countryCodes={countryCodes}
				/>
			);
		if (tabKey === "2")
			return <CompanyDetails data={companyDetails} fetchData={fetchData} />;
		if (tabKey === "3") return <UserManagement countryCodes={countryCodes} />;
		return null;
	};

	const renderSideBar = () => {
		return (
			<Menu
				defaultSelectedKeys={["1"]}
				mode="inline"
				theme="light"
				inlineIndent={1}
				style={{ backgroundColor: "white" }}
			>
				<Menu.Item
					key="1"
					icon={<BiDetail size={20} />}
					onClick={() => handleTabChange("1")}
				>
					Account Details
				</Menu.Item>
				{accountDetails?.isAdmin && (
					<Menu.Item
						key="2"
						icon={<IoCheckmarkCircle size={20} />}
						onClick={() => handleTabChange("2")}
					>
						Company Details
					</Menu.Item>
				)}
				{accountDetails?.isAdmin && (
					<Menu.Item
						key="3"
						icon={<IoPeopleCircleSharp size={20} />}
						onClick={() => handleTabChange("3")}
					>
						Users
					</Menu.Item>
				)}
			</Menu>
		);
	};

	const handleTabChange = (val) => {
		setTabKey(val);
	};

	return (
		<div>
			{renderHeader()}
			<Row
				style={{
					borderTop: "1px solid rgb(233, 234, 233)",
					paddingTop: "1rem",
				}}
			>
				<Col span={4}>{renderSideBar()}</Col>
				<Col span={20} style={{ paddingTop: "0.7rem", paddingLeft: "3rem" }}>
					{renderBody()}
				</Col>
			</Row>
		</div>
	);
}
